import { getCustomerIdValue, getInsuranceQuotationIdValue } from '../../../selectors/ugMotorInsurance/quote';
import { getDeclarationsForm } from '../../../selectors/ugMotorInsurance/declarations';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getDocuments } from '../../../selectors/ugMotorInsurance/documents';
import { uploadSingleDocumentService } from './uploadDocuments';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/ugMotorInsurance/quote';
import { setDeclarationsSubmittedValue } from '../../../actions/ugMotorInsurance/declarations';
import { collectLoginDetails } from '../../../actions/ugMotorInsurance/auth';
import { navigateToPayment } from '../../../actions/ugMotorInsurance/routing';

export const submitDeclarationsService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    store.dispatch(setShowTaggingErrorModal(false));
    store.dispatch(setTaggingErrorMessage(null));
    store.dispatch(apiTransitionPayloadCollection.pending());
    try {
        const documents = getDocuments(state);

        const declarations = getDeclarationsForm(state);

        if (documents.salesAgreement?.value?.base64File && declarations.purchaseAgreement?.value === 'true') {
            uploadSingleDocumentService(store, next, action);
        }

        await makeSubmission(state);

        store.dispatch(setDeclarationsSubmittedValue(true));

        store.dispatch(navigateToPayment());
    } catch (error) {
        console.error(error);

        store.dispatch(setDeclarationsSubmittedValue(false));
        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const payloadCollection = (state) => {
    const declarations = getDeclarationsForm(state);

    const customerId = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const declarationsPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        proposalDeclinedBefore:
            declarations.declineProposal?.value === 'true' || declarations.declineProposal?.value === true,
        specialPremiumBefore:
            declarations.increasedPremiums?.value === 'true' || declarations.increasedPremiums?.value === true,
        declinedForRenewalBefore:
            declarations.policyRejected?.value === 'true' || declarations.policyRejected?.value === true,
        convictionHistory: declarations.convicted?.value === 'true' || declarations.convicted?.value === true,
        healthIssues: declarations.defectVision?.value === 'true' || declarations.defectVision?.value === true,
        stickerCollectionPoint: declarations.stickerCollection?.value || 'N/A',
        sourceOfFunds:
            declarations.sourceOfFunds?.value && declarations.sourceOfFunds.value !== 'Other'
                ? declarations.sourceOfFunds.value
                : 'N/A',
        soleOwnership: declarations.soleOwnership?.value === 'true',
        hirePurchaseOrLoanAgreement: declarations.purchaseAgreement?.value === 'true',
        parkingLocation: declarations.parking?.value || 'N/A',
        usedForDomesticOrPleasurePurpose: declarations.domesticPurposes?.value === 'true',
        usedForBusinessOrProfesionalPurpose: declarations.businessPurposes?.value === 'true',
        usedByEmployeesOrOtherParties: declarations.employeeUse?.value === 'true',
        usedForTradeSamplesOrGoodsCarriage: declarations.tradeGoodsUse?.value === 'true',
        usedForAnyOtherPurpose:
            declarations.otherPurposeUse?.value === 'true' ? declarations.otherPurposeDesc?.value || 'N/A' : 'N/A',
        companyName:
            declarations.purchaseAgreement?.value === 'true' ? declarations.companyName?.value || 'N/A' : 'N/A',
    };

    return {
        ...declarationsPayload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/declarations';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
